module.exports = __webpack_public_path__ + "img/36988-023.c2888be4.jpg";